import { I18nt } from 'utils';
import ContactForm from './ContactForm';
import styles from './Contact.module.less';
import BannerWithImage from 'components/BannerWithImage';

function Contact() {
	return (
		<section className={styles.formPage}>
			<BannerWithImage>
				<div className={styles.headerContainer}>
					<h4 className='ml-8'>{I18nt('compartenos_tu_opinion')}</h4>
					<p className='pr-8 pl-8 pb-16'>{I18nt('estamos_mejorando')}</p>
					<p className='pr-8 pl-8'>{I18nt('te_invitamos_a_completar')}</p>
				</div>
				<div className={styles.formContainer}>
					<ContactForm />
				</div>
			</BannerWithImage>
		</section>
	);
}

export default Contact;
